import QRCode from 'qrcode-generator';
import globalIP from '../../GlobelIP';
import jsPDF from 'jspdf';

const loadImageDimensions = url => {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.src = url;
  });
};

const loadImageSafe = async url => {
  try {
    const dimensions = await loadImageDimensions(url);
    return dimensions;
  } catch (error) {
    console.error(`Failed to load image from URL: ${url}`, error);
    return null; // Return null if the image fails to load
  }
};
const handleDownloadQR1 = async (productData, printOrNot, data1) => {
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
  const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = logoUrl ? `${globalIP}${logoUrl}` : null;
  const boxWidth = 50;
  const boxHeight = 50;
  const boxesPerRow = 4;
  const maxBoxesPerPage = 20;

  const margin = 3; // Define the margin (you can change this value as per your need)

  if (productData.length === 0) {
    alert('No rows selected for export QR Code2!');
    return;
  }

  for (const [index, product] of productData.entries()) {
    if (index % maxBoxesPerPage === 0 && index !== 0) {
      pdf.addPage();
    }

    const relativeIndex = index % maxBoxesPerPage;
    const row = Math.floor(relativeIndex / boxesPerRow);
    const col = relativeIndex % boxesPerRow;

    // Adjust box position based on margin
    const boxX = margin + col * (boxWidth + 1);
    const boxY = margin + row * (boxHeight + 1);

    pdf.rect(boxX, boxY, boxWidth, boxHeight); // Draw box

    // Add logo with adjusted position
    if (img) {
      const logoDimensions = await loadImageSafe(img);
      if (logoDimensions) {
        const maxLogoWidth = 25;
        const maxLogoHeight = 7;

        let logoWidth = logoDimensions.width;
        let logoHeight = logoDimensions.height;

        const logoWidthRatio = maxLogoWidth / logoWidth;
        const logoHeightRatio = maxLogoHeight / logoHeight;
        const logoScaleRatio = Math.min(logoWidthRatio, logoHeightRatio);

        if (logoScaleRatio < 1) {
          logoWidth *= logoScaleRatio;
          logoHeight *= logoScaleRatio;
        }

        const logoX = 12.5 + boxX + (maxLogoWidth - logoWidth) / 2;
        const logoY = 2 + boxY + (maxLogoHeight - logoHeight) / 2;

        pdf.addImage(img, 'JPEG', logoX - 4, logoY - 1, logoWidth * 1.3, logoHeight * 1.3);
      }
    }

    // Generate and add QR code
    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });
    const qrCodeWidth = 28;
    const qrCodeHeight = 28;

    // Adjust QR code position
    const qrCodeX = boxX + (boxWidth - qrCodeWidth) / 2;
    const qrCodeY = boxY + 10; // Position QR code with some margin from top

    pdf.addImage(qrCodeImage, 'JPEG', qrCodeX, qrCodeY, qrCodeWidth, qrCodeHeight);

    // Add text below the QR code and size text
    pdf.setFontSize(10);
    const codeText = `Code: ${product.code}`;
    // pdf.setFontSize(8);
    const sizeText = `Size: ${product.size}`;

    const codeTextWidth = pdf.getTextWidth(codeText);
    const sizeTextWidth = pdf.getTextWidth(sizeText);

    // Adjust text positions based on margin and text width
    const codeTextX = boxX + (boxWidth - codeTextWidth) / 2;
    const sizeTextX = boxX + (boxWidth - sizeTextWidth) / 2;

    const codeTextY = qrCodeY + qrCodeHeight + 5;
    const sizeTextY = codeTextY + 5;

    pdf.text(codeText, codeTextX, codeTextY);
    pdf.text(sizeText, sizeTextX, sizeTextY);
  }

  // Generate the PDF as a Blob
  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (printOrNot === 'Print') {
    // Open the PDF in a new tab for printing
    window.open(blobUrl, '_blank');
  } else {
    // Create a download link for the PDF
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'Product_List.pdf';
    downloadLink.click();
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};

const handleDownloadQR2 = async (productData, printOrNot, data1) => {
  const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size in mm
  const cmpName = data1?.length > 0 ? data1[0].attributes?.cmpnm : '';
  const boxWidth = 30; // 3cm = 30mm
  const boxHeight = 30; // 3cm = 30mm
  const boxesPerRow = Math.floor((210 - 1) / (boxWidth + 1)); // A4 width (210mm) minus margins
  const boxesPerColumn = Math.floor((297 - 1) / (boxHeight + 1)); // A4 height (297mm) minus margins
  const maxBoxesPerPage = boxesPerRow * boxesPerColumn; // Calculate max boxes per page

  // Calculate total width and height used by the boxes
  const totalBoxWidth = boxesPerRow * (boxWidth + 1) - 1; // Total width including gaps
  const totalBoxHeight = boxesPerColumn * (boxHeight + 1) - 1; // Total height including gaps

  // Calculate margins to center boxes
  const marginLeft = (210 - totalBoxWidth) / 2; // Left margin (for centering)
  const marginTop = (297 - totalBoxHeight) / 2; // Top margin (for centering)

  if (productData.length === 0) {
    alert('No rows selected for export QR Code!');
    return;
  }

  for (const [index, product] of productData.entries()) {
    if (index % maxBoxesPerPage === 0 && index !== 0) {
      pdf.addPage();
    }

    const relativeIndex = index % maxBoxesPerPage;
    const row = Math.floor(relativeIndex / boxesPerRow);
    const col = relativeIndex % boxesPerRow;

    // Adjust box position by adding the margins
    const boxX = marginLeft + col * (boxWidth + 1);
    const boxY = marginTop + row * (boxHeight + 1);

    pdf.rect(boxX, boxY, boxWidth, boxHeight);

    pdf.setFontSize(8);
    const logoText = `${cmpName}`;
    pdf.setFont('helvetica', 'bold');
    const logoTextWidth = pdf.getTextWidth(logoText);
    const logoX = boxX + (boxWidth - logoTextWidth) / 2;
    const logoY = boxY + 4;
    pdf.text(logoText, logoX, logoY);

    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });
    const qrCodeSize = 20 * 0.75;
    const qrCodeX = boxX + (boxWidth - qrCodeSize) / 2;
    const qrCodeY = boxY + 6;
    pdf.addImage(qrCodeImage, 'JPEG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(0, 0, 0);

    const codeText = `Code : ${product.code}`;
    const sizeText = `${product.size}`;
    const codeTextWidth = pdf.getTextWidth(codeText);
    const sizeTextWidth = pdf.getTextWidth(sizeText);

    const codeTextX = boxX + (boxWidth - codeTextWidth) / 2;
    const sizeTextX = boxX + (boxWidth - sizeTextWidth) / 2;

    const codeTextY = qrCodeY + qrCodeSize + 4;
    const sizeTextY = codeTextY + 3;

    pdf.text(codeText, codeTextX, codeTextY);
    pdf.text(sizeText, sizeTextX, sizeTextY);
  }

  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (printOrNot === 'Print') {
    window.open(blobUrl, '_blank');
  } else {
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'Product_List.pdf';
    downloadLink.click();
  }

  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};

const handleDownloadQR3 = async (productData, printOrNot, data1) => {
  const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size in mm
  pdf.setTextColor(0, 0, 0);

  const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = logoUrl ? `${globalIP}${logoUrl}` : null;

  const boxWidth = 90;
  const boxesPerRow = 2;
  const maxBoxesPerPage = 10;

  if (productData.length === 0) {
    alert('No rows selected for export QR Code!');
    return;
  }

  const loadImageSafe = async url => {
    try {
      const dimensions = await loadImageDimensions(url);
      return dimensions;
    } catch (error) {
      console.error(`Failed to load image from URL: ${url}`, error);
      return null;
    }
  };

  const reversedCata = [...productData];

  let boxX = 14;
  let boxY = 18;
  let currentRowMaxHeight = 0;
  let currentCol = 0;
  let boxCount = 0;

  for (const [index, product] of reversedCata.entries()) {
    if (boxCount === maxBoxesPerPage) {
      pdf.addPage();
      boxX = 14;
      boxY = 18;
      currentRowMaxHeight = 0;
      currentCol = 0;
      boxCount = 0;
    }

    let currentY = boxY;
    let boxHeight = 50;

    const img1 = product.image;
    const imgp = img1 ? `${globalIP}${img1}` : null;
    const productImageDimensions = imgp ? await loadImageSafe(imgp) : null;

    if (productImageDimensions) {
      const maxImageWidth = 30;
      const maxImageHeight = 30;
      let productImageWidth = productImageDimensions.width;
      let productImageHeight = productImageDimensions.height;

      const widthRatio = maxImageWidth / productImageWidth;
      const heightRatio = maxImageHeight / productImageHeight;
      const scaleRatio = Math.min(widthRatio, heightRatio);

      if (scaleRatio < 1) {
        productImageWidth *= scaleRatio;
        productImageHeight *= scaleRatio;
      }

      const centeredX = 55 + boxX + (maxImageWidth - productImageWidth) / 2;
      const centeredY = 7 + boxY + (maxImageHeight - productImageHeight) / 2;
      pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
    }

    if (img) {
      const logoDimensions = await loadImageSafe(img);
      if (logoDimensions) {
        const maxLogoWidth = 22;
        const maxLogoHeight = 7;

        let logoWidth = logoDimensions.width;
        let logoHeight = logoDimensions.height;

        const logoWidthRatio = maxLogoWidth / logoWidth;
        const logoHeightRatio = maxLogoHeight / logoHeight;
        const logoScaleRatio = Math.min(logoWidthRatio, logoHeightRatio);

        if (logoScaleRatio < 1) {
          logoWidth *= logoScaleRatio;
          logoHeight *= logoScaleRatio;
        }

        const logoX = 6 + boxX + (maxLogoWidth - logoWidth) / 2;
        const logoY = 1 + boxY + (maxLogoHeight - logoHeight) / 2;

        pdf.addImage(img, 'JPEG', logoX - 2, logoY - 1.5, logoWidth * 1.5, logoHeight * 1.1);
      }
    }

    // Product Code
    pdf.setFont('sans-serif', 'bold');
    pdf.setFontSize(10);
    pdf.text('Code :', 55 + boxX, 5 + boxY - 1.5);
    pdf.text(`${product.code}`, 66 + boxX, 5 + boxY - 1.5);
    pdf.setFontSize(8);
    // QR Code
    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });
    const qrCodeWidth = 38 * 0.76;
    const qrCodeHeight = 35 * 0.76;
    pdf.addImage(qrCodeImage, 'JPEG', 2 + boxX + 3, boxY + 9, qrCodeWidth, qrCodeHeight);

    // Name (multi-line)
    const nameX = 15 + boxX;
    const nameY = 39 + boxY;
    const nameMaxWidth = 70;
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Name : `, 5 + boxX, 39 + boxY);
    const nameLines = pdf.splitTextToSize(product.name, nameMaxWidth);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(nameLines, nameX, nameY);

    const lineHeight = 3.8;
    const nameHeight = nameLines.length * lineHeight;
    let afterNameY = nameY + nameHeight;

    // Material
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Material : `, 5 + boxX, afterNameY);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(`${product.material}`, 6 + boxX + pdf.getTextWidth('Material : '), afterNameY);

    // Finish
    afterNameY += lineHeight;
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Finish : `, 5 + boxX, afterNameY);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(`${product.finish}`, 6 + boxX + pdf.getTextWidth('Finish : '), afterNameY);

    // Net Weight
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Net Wt : `, 70 + boxX, afterNameY);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(`${product.ntwt}`, 70 + boxX + pdf.getTextWidth('Net Wt : '), afterNameY);

    const finalBottomY = afterNameY + 3;
    boxHeight = finalBottomY - boxY;
    pdf.rect(boxX, boxY, boxWidth, boxHeight);

    currentRowMaxHeight = Math.max(currentRowMaxHeight, boxHeight);
    currentCol++;
    boxCount++;

    if (currentCol < boxesPerRow) {
      boxX += boxWidth + 2;
    } else {
      boxX = 14;
      boxY += currentRowMaxHeight + 3;
      currentCol = 0;
      currentRowMaxHeight = 0;
    }
  }

  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (printOrNot === 'Print') {
    window.open(blobUrl, '_blank');
  } else {
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'Product_List.pdf';
    downloadLink.click();
  }

  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};

const handleDownloadQR4 = async (productData, data1) => {
  const pdf = new jsPDF();
  const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = `${globalIP}${logoUrl}`;
  const boxWidth = 99;
  const boxHeight = 56;
  const boxesPerRow = 2; // Number of boxes per row
  const maxBoxesPerPage = 10;
  // Iterate over each product in productData
  // if (productData.length === 0) {
  //   alert('No rows selected for export QR Code2!');
  //   return;
  // }
  for (const [index, product] of productData.entries()) {
    if (index % maxBoxesPerPage === 0 && index !== 0) {
      pdf.addPage();
    }
    const relativeIndex = index % maxBoxesPerPage;
    const row = Math.floor(relativeIndex / boxesPerRow);
    const col = relativeIndex % boxesPerRow;
    // Calculate the starting point of each box based on row and column
    const boxX = 2 + col * (boxWidth + 2); // 5 is the horizontal margin between boxes
    const boxY = 3 + row * (boxHeight + 3); // 5 is the vertical margin between boxes
    // Draw a box for each product
    pdf.rect(boxX, boxY, boxWidth, boxHeight);
    // Define the box properties for the logo within each box
    // const logoWidth = 22; // Adjust the logo width as needed
    // const logoHeight = 7; // Adjust the logo height as needed
    // const logoX = 6 + boxX; // Adjust the X position as needed
    // const logoY = 1 + boxY; // Adjust the Y position as needed
    const logoXi = 55 + boxX; // Adjust the X position as needed
    const logoYi = 7 + boxY; // Adjust the Y position as needed
    // Add the logo to the PDF within each box
    const img1 = product.image;
    // console.log(img1);
    if (img1) {
      const imgp = img1 ? `${globalIP}${img1}` : '';
      const productImageDimensions = await loadImageDimensions(imgp);
      const maxImageWidth = 30; // Adjust to fit the container
      const maxImageHeight = 30;

      let productImageWidth = productImageDimensions.width;
      let productImageHeight = productImageDimensions.height;

      const widthRatio = maxImageWidth / productImageWidth;
      const heightRatio = maxImageHeight / productImageHeight;
      const scaleRatio = Math.min(widthRatio, heightRatio);

      if (scaleRatio < 1) {
        productImageWidth *= scaleRatio;
        productImageHeight *= scaleRatio;
      }

      // Center the image within the container
      const centeredX = 55 + boxX + (maxImageWidth - productImageWidth) / 2;
      const centeredY = 7 + boxY + (maxImageHeight - productImageHeight) / 2;

      pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
    }

    // Add the logo with similar scaling and positioning logic
    const logoDimensions = await loadImageDimensions(img);
    const maxLogoWidth = 22;
    const maxLogoHeight = 7;

    let logoWidth = logoDimensions.width;
    let logoHeight = logoDimensions.height;

    const logoWidthRatio = maxLogoWidth / logoWidth;
    const logoHeightRatio = maxLogoHeight / logoHeight;
    const logoScaleRatio = Math.min(logoWidthRatio, logoHeightRatio);

    if (logoScaleRatio < 1) {
      logoWidth *= logoScaleRatio;
      logoHeight *= logoScaleRatio;
    }

    const logoX = 6 + boxX + (maxLogoWidth - logoWidth) / 2;
    const logoY = 1 + boxY + (maxLogoHeight - logoHeight) / 2;

    pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

    pdf.setFont('sans-serif', 'bold');
    pdf.setFontSize(8);
    pdf.text('Tag Code :', 6 + boxX, 44 + boxY);
    pdf.text('Name :', 6 + boxX, 48 + boxY);
    pdf.setFont('sans-serif', 'normal');
    pdf.setFontSize(8);
    pdf.text(`${product.code}`, 22 + boxX, 44 + boxY); // Adjust X position to place the value after the label
    pdf.text(`${product.name}`, 16 + boxX, 48 + boxY);
    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL();
    const qrCodeWidth = 38;
    const qrCodeHeight = 35;
    pdf.addImage(qrCodeImage, 'JPEG', 2 + boxX, boxY + 5.7, qrCodeWidth, qrCodeHeight);
    pdf.addImage(img, 'JPEG', logoX, logoY + 0.5, logoWidth, logoHeight);
    pdf.setFont('sans-serif', 'bold');
    pdf.setFontSize(8);
    pdf.text('Grs Wt :', 55 + boxX, 44 + boxY);
    pdf.text('Net Wt :', 74 + boxX, 44 + boxY);

    pdf.setFont('sans-serif', 'normal');
    pdf.setFontSize(8);
    pdf.text(`${product.grwt}`, 67 + boxX, 44 + boxY);
    pdf.text(`${product.ntwt}`, 86 + boxX, 44 + boxY);

    pdf.setFont('sans-serif', 'italic', 'bold');
    pdf.text('Powered By :', 6 + boxX, 53 + boxY);
    pdf.setTextColor(24, 61, 104);
    pdf.setFontSize(8);
    pdf.text('ERPDaddy Software Solution(P) Ltd.', 23 + boxX, 53 + boxY);
    pdf.setTextColor(0, 0, 0);
  }
  pdf.save('QRPrint.pdf');
};

const handleDownloadQR5 = (productData, data1) => {
  const pdf = new jsPDF();
  const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = `${globalIP}${logoUrl}`;
  const boxWidth = 51;
  const boxHeight = 60;
  const boxesPerRow = 4; // Number of boxes per row
  const maxBoxesPerPage = 20;

  // Load the logo image and calculate its natural dimensions
  const logoImage = new Image();
  logoImage.src = img;

  logoImage.onload = function () {
    const logoWidthRatio = 25; // Target width for the logo in the box
    const logoHeightRatio = 7; // Target height for the logo in the box

    // Calculate natural aspect ratio
    const aspectRatio = logoImage.width / logoImage.height;

    // Adjust the width and height based on the aspect ratio to fit the target area
    let logoWidthAdjusted = logoWidthRatio;
    let logoHeightAdjusted = logoWidthAdjusted / aspectRatio;

    if (logoHeightAdjusted > logoHeightRatio) {
      logoHeightAdjusted = logoHeightRatio;
      logoWidthAdjusted = logoHeightAdjusted * aspectRatio;
    }

    // Iterate over each product in productData
    productData.forEach((product, index) => {
      if (index % maxBoxesPerPage === 0 && index !== 0) {
        pdf.addPage();
      }
      const relativeIndex = index % maxBoxesPerPage;
      const row = Math.floor(relativeIndex / boxesPerRow);
      const col = relativeIndex % boxesPerRow;

      const boxX = 1 + col * (boxWidth + 1);
      const boxY = 1 + row * (boxHeight + 1);

      pdf.rect(boxX, boxY, boxWidth, boxHeight);

      // Add the resized logo to the PDF
      const logoX = 22 + boxX;
      const logoY = 2 + boxY;
      pdf.addImage(img, 'JPEG', logoX, logoY, logoWidthAdjusted, logoHeightAdjusted);

      const qrCode = QRCode(0, 'L');
      qrCode.addData(product.pcode);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL();
      const qrCodeWidth = 40;
      const qrCodeHeight = 40;
      pdf.addImage(qrCodeImage, 'JPEG', 5.5 + boxX, boxY + 9, qrCodeWidth, qrCodeHeight);

      pdf.setFontSize(10);
      pdf.text(`Code : ${product.code}`, 15.5 + boxX, 48 + boxY);
      pdf.text('Powered By', 15.5 + boxX, 53 + boxY);
      pdf.setTextColor(46, 120, 204);
      pdf.setFontSize(8);
      pdf.text('ERPDADDY Software Solution(p) Ltd.', 2 + boxX, 58 + boxY);
      pdf.setTextColor(0, 0, 0);
    });

    pdf.save('QRPrint.pdf');
  };
};
const handleDownloadQR6 = async (productData, printOrNot, data1) => {
  console.log(productData)
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 1;

  const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = logoUrl ? `${globalIP}${logoUrl}` : null;
  
  if (productData.length === 0) {
    alert('No rows selected for export QR Code!');
    return;
  }

  let logoBase64 = null;
  if (img) {
    logoBase64 = await loadImageAsBase64(img);
  }

  const blockSpacing = 4; // mm spacing between blocks
  const spacing = 1.5; // mm vertical spacing between logo, QR, and text
  const textAreaHeight = 4; // mm height for text area
  const borderPadding = 1.5; // padding inside border

  let x = margin;
  let y = margin;

  for (let i = 0; i < productData.length; i++) {
    const product = productData[i];

    // Max logo size reduced to fit block
    let actualLogoWidth = 0;
    let actualLogoHeight = 0;
    if (logoBase64) {
      const logoDimensions = await loadImageSafe(img);
      if (logoDimensions) {
        let logoWidth = logoDimensions.width;
        let logoHeight = logoDimensions.height;

        const maxLogoWidth = 30; // max width in mm (~2 cm)
        const maxLogoHeight = 5; // max height in mm

        const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
        actualLogoWidth = logoWidth * scale;
        actualLogoHeight = logoHeight * scale;
      }
    }

    const qrCodeSize = 24; // 20 mm = 2 cm

    // Calculate total content width and height for border
    const originalContentWidth = Math.max(actualLogoWidth, qrCodeSize) + borderPadding * 2;
    const extraWidth = 2.5; // your requested width increase
    const contentWidth = originalContentWidth + extraWidth;
    const bottomTrim = 2; // Reduce border height from bottom
    const contentHeight =
      actualLogoHeight +
      spacing +
      qrCodeSize +
      spacing +
      textAreaHeight +
      borderPadding * 2 -
      bottomTrim;

    // Check for horizontal page break
    if (x + contentWidth + margin > pageWidth) {
      x = margin;
      y += contentHeight + blockSpacing;
    }

    // Check for vertical page break
    if (y + contentHeight + margin > pageHeight) {
      pdf.addPage();
      x = margin;
      y = margin;
    }

    // Draw border around content
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.3);
    pdf.rect(x, y, contentWidth, contentHeight);

    // Draw logo centered inside border with padding
    if (logoBase64 && actualLogoHeight > 0) {
      const logoX = x + (contentWidth - actualLogoWidth) / 2;
      const logoY = y + borderPadding;
      pdf.addImage(logoBase64, 'PNG', logoX, logoY, actualLogoWidth, actualLogoHeight);
    }

    // Draw QR code below logo
    const qrX = x + (contentWidth - qrCodeSize) / 2;
    const qrY = y + borderPadding + actualLogoHeight + spacing;

    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

    pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

    // Draw text below QR code
    const textY = qrY + qrCodeSize + spacing + 2; // small baseline tweak
    pdf.setFontSize(12);
    pdf.text(`${product.code}`, x + contentWidth / 2, textY, { align: 'center' });

    // Move x for next block horizontally
    x += contentWidth + blockSpacing;
  }

  pdf.save('QRPrint.pdf');
};

// Utility: Convert image URL to Base64
const loadImageAsBase64 = url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = err => reject(err);
    img.src = url;
  });
};
const handleDownloadQR7 = async (productData, printOrNot, data1) => {
  console.log("first")
  const pageSizeMM = 127; // 6 inches in mm
  const pdf = new jsPDF({ unit: 'mm', format: [pageSizeMM, pageSizeMM] });

  const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = logoUrl ? `${globalIP}${logoUrl}` : null;

  if (productData.length === 0) {
    alert('No rows selected for export QR Code!');
    return;
  }

  for (const [index, product] of productData.entries()) {
    if (index !== 0) {
      pdf.addPage(); // new page for each product
    }

    const pageWidth = pdf.internal.pageSize.getWidth();

    const margin = 6.5;

    // Draw logo (top center)
    if (img) {
      const logoDimensions = await loadImageSafe(img);
      if (logoDimensions) {
        const maxLogoWidth = 100;
        const maxLogoHeight = 35;

        let logoWidth = logoDimensions.width;
        let logoHeight = logoDimensions.height;

        const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
        logoWidth *= scale;
        logoHeight *= scale;

        const logoX = (pageWidth - logoWidth) / 2;
        const logoY = margin;

        pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);
      }
    }

    // Generate and add QR code (center)
    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

    const qrCodeSize = 70; // smaller for small page
    const qrX = (pageWidth - qrCodeSize) / 2;
    const qrY = 30;

    pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

    // Add Alias Code and Size (bottom center)
    const codeText = `Alias Code: ${product.code}`;
    const sizeText = `Size: ${product.size}`;

    pdf.setFontSize(18);
    const codeWidth = pdf.getTextWidth(codeText);
    const sizeWidth = pdf.getTextWidth(sizeText);

    const codeX = (pageWidth - codeWidth) / 2;
    const sizeX = (pageWidth - sizeWidth) / 2;

    const codeY = qrY + qrCodeSize + 10;
    const sizeY = codeY + 8;

    pdf.text(codeText, codeX, codeY);
    pdf.text(sizeText, sizeX, sizeY);
  }

  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (printOrNot === 'Print') {
    window.open(blobUrl, '_blank');
  } else {
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'QR_List.pdf';
    downloadLink.click();
  }

  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};
const handleDownloadQR9 = async (productData, printOrNot, data1) => {
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 1;

  const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = logoUrl ? `${globalIP}${logoUrl}` : null;

  if (productData.length === 0) {
    alert('No rows selected for export QR Code!');
    return;
  }

  let logoBase64 = null;
  if (img) {
    logoBase64 = await loadImageAsBase64(img);
  }

  const blockSpacing = 4; // mm spacing between blocks
  const spacing = 1.5; // mm vertical spacing between logo, QR, and text
  const textAreaHeight = 8; // mm height for text area
  const borderPadding = 1.5; // padding inside border

  let x = margin;
  let y = margin;

  for (let i = 0; i < productData.length; i++) {
    const product = productData[i];

    // Max logo size reduced to fit block
    let actualLogoWidth = 0;
    let actualLogoHeight = 0;
    if (logoBase64) {
      const logoDimensions = await loadImageSafe(img);
      if (logoDimensions) {
        let logoWidth = logoDimensions.width;
        let logoHeight = logoDimensions.height;

        const maxLogoWidth = 30; // max width in mm (~2 cm)
        const maxLogoHeight = 5; // max height in mm

        const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
        actualLogoWidth = logoWidth * scale;
        actualLogoHeight = logoHeight * scale;
      }
    }

    const qrCodeSize = 24; // 20 mm = 2 cm

    // Calculate total content width and height for border
    const originalContentWidth = Math.max(actualLogoWidth, qrCodeSize) + borderPadding * 2;
    const extraWidth = 2.5; // your requested width increase
    const contentWidth = originalContentWidth + extraWidth;
    const bottomTrim = 2; // Reduce border height from bottom
    const contentHeight =
      actualLogoHeight +
      spacing +
      qrCodeSize +
      spacing +
      textAreaHeight +
      borderPadding * 2 -
      bottomTrim;

    // Check for horizontal page break
    if (x + contentWidth + margin > pageWidth) {
      x = margin;
      y += contentHeight + blockSpacing;
    }

    // Check for vertical page break
    if (y + contentHeight + margin > pageHeight) {
      pdf.addPage();
      x = margin;
      y = margin;
    }

    // Draw border around content
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.3);
    pdf.rect(x, y, contentWidth, contentHeight);

    // Draw logo centered inside border with padding
    if (logoBase64 && actualLogoHeight > 0) {
      const logoX = x + (contentWidth - actualLogoWidth) / 2;
      const logoY = y + borderPadding;
      pdf.addImage(logoBase64, 'PNG', logoX, logoY, actualLogoWidth, actualLogoHeight);
    }

    // Draw QR code below logo
    const qrX = x + (contentWidth - qrCodeSize) / 2;
    const qrY = y + borderPadding + actualLogoHeight + spacing;

    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

    pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

    // Draw text below QR code
    const textY = qrY + qrCodeSize + spacing + 2; // small baseline tweak
    pdf.setFontSize(10);
    pdf.text(`${product.code}`, x + contentWidth / 2, textY, { align: 'center' });

    const secondLineY = textY + 4; // 4mm below the first line (adjust as needed)
    pdf.setFontSize(10);
    pdf.text(`${product.size}`, x + contentWidth / 2, secondLineY, { align: 'center' });

    // Move x for next block horizontally
    x += contentWidth + blockSpacing;
  }

  pdf.save('QRPrint.pdf');
};
const handleDownloadQR8 = async (productData, printOrNot, data1) => {
  const pdf = new jsPDF({ unit: 'mm', orientation: 'landscape', format: [127, 228.6] });

  const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = logoUrl ? `${globalIP}${logoUrl}` : null;

  if (productData.length === 0) {
    alert('No rows selected for export QR Code!');
    return;
  }

  let boxX = 1;
  let boxY = 1;
  let boxHeight = 124.5;
  let boxWidth = 226;

  for (const [index, product] of productData.entries()) {
    if (index !== 0) {
      pdf.addPage(); // new page for each product
    }

    pdf.rect(boxX, boxY, boxWidth, boxHeight);
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 2;
    const usableWidth = pageWidth - 2 * margin;
    let startX = 0;

    // Draw logo (top center)
    if (img) {
      const logoDimensions = await loadImageSafe(img);
      if (logoDimensions) {
        const maxLogoWidth = 75;
        const maxLogoHeight = 22;

        let logoWidth = logoDimensions.width;
        let logoHeight = logoDimensions.height;

        const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
        logoWidth *= scale;
        logoHeight *= scale;

        const logoX = 15;
        const logoY = margin;

        pdf.addImage(img, 'JPEG', logoX, logoY, 75, logoHeight - 0.5);
        startX = logoX;
      }
    }

    // Generate and add QR code (center)
    const qrCode = QRCode(0, 'L');
    qrCode.addData(product.pcode);
    qrCode.make();
    const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

    const qrCodeSize = 75; // smaller for small page
    const qrX = pageWidth / 2 - qrCodeSize;
    const qrY = 22;

    pdf.addImage(qrCodeImage, 'JPEG', startX, qrY, qrCodeSize, qrCodeSize);

    // Add Alias Code and Size (bottom center)
    // const name = `Name: ${product.name}`;
    // const material = `Material: ${product.material}`;
    // const finish = `Finish: ${product.finish}`;
    // const codeText = `Alias Code: ${product.code}`;
    // const weight = `Net Wt: ${product.ntwt}`;

    // pdf.setFontSize(14);
    // // const codeWidth = pdf.getTextWidth(codeText);
    // // const sizeWidth = pdf.getTextWidth(sizeText);

    // // const codeX = (pageWidth - codeWidth) / 2;
    // // const sizeX = (pageWidth - sizeWidth) / 2;

    // const codeY = qrY + qrCodeSize + 10;
    // const sizeY = codeY + 8;
    // pdf.text(name, startX, codeY-1);
    // pdf.text(material, startX, codeY+6);
    // pdf.text(finish, startX, codeY+13);
    // pdf.text(codeText, startX * 4 + qrCodeSize, startX);
    // pdf.text(weight, startX * 4 + qrCodeSize * 1.6, codeY+4);

    // Name
    const nameX = startX;
    const topMargin = 5; // add extra spacing from top
    const nameY = 30 + qrCodeSize + topMargin;
    const nameMaxWidth = 100;
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Name : `, nameX, nameY);
    const nameLines = pdf.splitTextToSize(product.name, nameMaxWidth);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(nameLines, nameX + pdf.getTextWidth('Name : '), nameY);

    const lineHeight = 3.8;
    const nameHeight = nameLines.length * lineHeight;
    let afterNameY = nameY + nameHeight;

    // Material
    // pdf.setFont('sans-serif', 'bold');
    // pdf.text(`Material : `, startX, afterNameY + lineHeight);
    // pdf.setFont('sans-serif', 'normal');
    // pdf.text(
    //   `${product.material}`,
    //   startX + pdf.getTextWidth('Material : '),
    //   afterNameY + lineHeight
    // );

    // Finish
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Finish : `, startX, afterNameY + lineHeight);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(
      `${product.finish}`,
      startX + pdf.getTextWidth('Finish : '),
      afterNameY + lineHeight
    );

    // Net Weight
    pdf.setFont('sans-serif', 'bold');
    pdf.text(`Net Wt : `, 70 * 2.6, afterNameY + lineHeight * 3);
    pdf.setFont('sans-serif', 'normal');
    pdf.text(
      `${product.ntwt}`,
      70 * 2.6 + pdf.getTextWidth('Net Wt : '),
      afterNameY + lineHeight * 3
    );

    const centeredX = startX * 4 + qrCodeSize;
    const centeredY = qrY;
    // Code
    pdf.setFontSize(25);
    pdf.setFont('sans-serif', 'bold');
    pdf.text('Code: ', centeredX, 10);
    pdf.text(`${product.code}`, centeredX + pdf.getTextWidth('Code: '), 10);
    pdf.setFontSize(15);

    const img1 = product.image;
    const imgp = img1 ? `${globalIP}${img1}` : null;
    const productImageDimensions = imgp ? await loadImageSafe(imgp) : null;

    if (productImageDimensions) {
      const maxImageWidth = qrCodeSize;
      const maxImageHeight = qrCodeSize;
      let productImageWidth = productImageDimensions.width;
      let productImageHeight = productImageDimensions.height;

      const widthRatio = maxImageWidth / productImageWidth;
      const heightRatio = maxImageHeight / productImageHeight;
      const scaleRatio = Math.min(widthRatio, heightRatio);

      if (scaleRatio < 1) {
        productImageWidth *= scaleRatio;
        productImageHeight *= scaleRatio;
      }

      pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
    }
  }

  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (printOrNot === 'Print') {
    window.open(blobUrl, '_blank');
  } else {
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'QR_List.pdf';
    downloadLink.click();
  }

  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};

export {
  handleDownloadQR1,
  handleDownloadQR2,
  handleDownloadQR3,
  handleDownloadQR4,
  handleDownloadQR5,
  handleDownloadQR6,
  handleDownloadQR7,
  handleDownloadQR8,
  handleDownloadQR9
};
